module.exports = __webpack_public_path__ + "media/images/lb/021-043c88d50961d317ee83bc945ee8ced5.svg";